<template>
  <section>
    <b-modal
      ref='modalTagEmailAutomation'
      id='modalTagEmailAutomation'
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      size='xl'
      scrollable
      @show='showModal()'
      @hide="$emit('update')"
    >
      <b-overlay
        :show="loadingOverlay"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
        class="d-inline-block w-100"
        style="min-height: 100px"
      >
        <section class='modal-font-family modal-instructional-videos'>
          <section class='d-flex justify-content-between align-items-start w-100 header '>
            <section>
              <p v-if="tagEmailAutomationId" class='title mb-0'>Editar e-mail</p>
              <p v-else class='title mb-0'>Adicionar e-mail</p>
              <span v-if="tagEmailAutomationId"  class="sub-title">Preencha os campos abaixo para editar o e-mail</span>
              <span v-else class="sub-title">Preencha os campos abaixo para adicionar o e-mail</span>
            </section>
            <section>
              <b-icon
                @click='closeModalTagEmailAutomation()'
                class='cursor-pointer'
                font-scale='2.5'
                icon='x'
                color='#022245'
              >
              </b-icon>
            </section>
          </section>

          <section>
            <hr />
          </section>

          <section class=''>
            <section>
              <label class="pr-1 mb-1" for="filePhones">Importar lista de e-mails</label>
              <a class="pl-1 link-model" href="https://files-hofacil.s3.amazonaws.com/1772458024587">Baixar arquivo
                modelo</a>
            </section>

            <input type='file' id='filePhones' accept='.xlsx' @change='uploadEmails' hidden />
            <label class='file-product d-flex align-items-center' for='filePhones'>
              <svg class='mx-1' width='18' height='18' viewBox='0 0 10 18' fill='none'
                   xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M3.12969 6.00003V12.743C3.13748 13.2361 3.33882 13.7063 3.69026 14.0523C4.0417 14.3982 4.51507 14.5921 5.0082 14.5921C5.50134 14.5921 5.9747 14.3982 6.32615 14.0523C6.67759 13.7063 6.87893 13.2361 6.88672 12.743L6.89281 3.90472C6.89792 3.48328 6.81933 3.06502 6.66159 2.67418C6.50385 2.28334 6.2701 1.9277 5.97389 1.62787C5.67768 1.32804 5.3249 1.09 4.93601 0.927526C4.54711 0.765056 4.12983 0.681396 3.70836 0.681396C3.28689 0.681396 2.86961 0.765056 2.48071 0.927526C2.09182 1.09 1.73904 1.32804 1.44283 1.62787C1.14661 1.9277 0.912864 2.28334 0.755124 2.67418C0.597384 3.06502 0.518793 3.48328 0.523906 3.90472V12.8025C0.51532 13.3959 0.624765 13.985 0.84588 14.5356C1.067 15.0863 1.39537 15.5875 1.81191 16.0101C2.22845 16.4327 2.72484 16.7683 3.27223 16.9973C3.81962 17.2264 4.40709 17.3443 5.00047 17.3443C5.59385 17.3443 6.18132 17.2264 6.72871 16.9973C7.2761 16.7683 7.77249 16.4327 8.18903 16.0101C8.60557 15.5875 8.93394 15.0863 9.15506 14.5356C9.37617 13.985 9.48562 13.3959 9.47703 12.8025V4.48785'
                  stroke='#808080' stroke-miterlimit='10' stroke-linecap='round' />
              </svg>

              <strong v-if='fileEmails && fileEmails.name'>{{ fileEmails.name }}</strong>

              <span v-if='!fileEmails.name'>Clique aqui para anexar o arquivo.</span>
            </label>

            <b-alert show variant="warning" class="d-flex align-items-center mb-0 mt-2">
              Caso o arquivo contenha mais de uma aba, somente a primeira será processada. As demais serão desconsideradas.
            </b-alert>

            <section v-if="emails && emails.length > 0" class="mt-4">
              <section class="d-flex align-items-center">
                <h5><strong>Lista de e-mails</strong></h5>

                <b-tooltip target="deleteEmails" triggers="hover" placement="top">
                  Excluir e-mails
                </b-tooltip>

                <b-icon
                  @click="deleteEmails()"
                  id="deleteEmails"
                  class="mb-1 ml-2 cursor-pointer"
                  icon="trash"
                  variant="danger"
                ></b-icon>
              </section>

              <ul class="ml-3 phones-grid">
                <li v-for="(email, index) in emails" :key="index">
                  {{ email }}
                </li>
              </ul>
              <hr />
            </section>
          </section>

          <section class="mt-4">
            <section class="mb-2">
              <label for="triggerTag">Tags de gatilho</label>
              <b-tooltip target="tagExport" triggers="hover" placement="top">
                Exportar tag
              </b-tooltip>
              <b-icon v-if="tagEmailAutomation.triggerTag" id='tagExport' class="cursor-pointer ml-2"
                      @click="exportToExcel()" icon="file-excel-fill"></b-icon>
            </section>

            <b-form-select
              id="triggerTag"
              v-model="tagEmailAutomation.triggerTag"
              :options='tagsTagEmailAutomation'
              value-field='tag'
              text-field='tagDescription'
            >
            </b-form-select>
          </section>

          <section class="mt-4">
            <label for="emailSubject">Assunto</label>
            <b-form-input
              id="emailSubject"
              v-model="tagEmailAutomation.emailSubject"
              placeholder="Digite o assunto do email"
            >
            </b-form-input>
          </section>

          <section class="mt-4">
            <label class="mb-1" for="emailBody">E-mail</label>
            <quill-editor id="emailBody" v-model='tagEmailAutomation.emailBody'></quill-editor>
          </section>

          <section class="mt-4">
            <label class="mb-1" id="emailSendingType">Tipo de envio</label>
            <b-form-select
              id="emailSendingType"
              v-model='tagEmailAutomation.emailSendingType'
              :options='emailSendingType'
              class='mb-3'
              value-field='value'
              text-field='text'
            >
              <template #first>
                <b-form-select-option :value='null' disabled>Selecione o tipo de envio</b-form-select-option>
              </template>
            </b-form-select>
          </section>

          <section
            v-if="tagEmailAutomation.emailSendingType && tagEmailAutomation.emailSendingType === emailSendingTypeMultiple"
            class="w-100 mt-2 d-flex justify-content-between">
            <section class="w-50 pr-2">
              <label for="maxSendCount">Quantidade de e-mails a serem enviados</label>
              <b-form-input
                id="maxSendCount"
                type="number"
                v-model="tagEmailAutomation.maxSendCount"
                placeholder="Digite a quantidade de e-mails a serem enviados."
              >
              </b-form-input>
            </section>

            <section class="w-50 pl-2">
              <label for="sendIntervalDays">Intervalo, em dias, entre os envios de e-mail</label>
              <b-form-input
                type="number"
                id="sendIntervalDays"
                v-model="tagEmailAutomation.sendIntervalDays"
                placeholder="Digite o intervalo, em dias, entre os envios de e-mail"
              >
              </b-form-input>
            </section>
          </section>

          <section class='mt-4'>
            <label class="mb-2" for="file">Fazer upload de arquivo</label>

            <a class='file-uploaded mb-3' v-if='tagEmailAutomation && tagEmailAutomation.fileUrl'
               :href='tagEmailAutomation.fileUrl' target='_blank'>
              Clique aqui para ver o arquivo anexado anteriormente
            </a>

            <input type='file' id='file' @change='uploadFile' hidden />
            <label class='file-product d-flex align-items-center' for='file'>
              <svg class='ml-1 mr-1' width='18' height='18' viewBox='0 0 10 18' fill='none'
                   xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M3.12969 6.00003V12.743C3.13748 13.2361 3.33882 13.7063 3.69026 14.0523C4.0417 14.3982 4.51507 14.5921 5.0082 14.5921C5.50134 14.5921 5.9747 14.3982 6.32615 14.0523C6.67759 13.7063 6.87893 13.2361 6.88672 12.743L6.89281 3.90472C6.89792 3.48328 6.81933 3.06502 6.66159 2.67418C6.50385 2.28334 6.2701 1.9277 5.97389 1.62787C5.67768 1.32804 5.3249 1.09 4.93601 0.927526C4.54711 0.765056 4.12983 0.681396 3.70836 0.681396C3.28689 0.681396 2.86961 0.765056 2.48071 0.927526C2.09182 1.09 1.73904 1.32804 1.44283 1.62787C1.14661 1.9277 0.912864 2.28334 0.755124 2.67418C0.597384 3.06502 0.518793 3.48328 0.523906 3.90472V12.8025C0.51532 13.3959 0.624765 13.985 0.84588 14.5356C1.067 15.0863 1.39537 15.5875 1.81191 16.0101C2.22845 16.4327 2.72484 16.7683 3.27223 16.9973C3.81962 17.2264 4.40709 17.3443 5.00047 17.3443C5.59385 17.3443 6.18132 17.2264 6.72871 16.9973C7.2761 16.7683 7.77249 16.4327 8.18903 16.0101C8.60557 15.5875 8.93394 15.0863 9.15506 14.5356C9.37617 13.985 9.48562 13.3959 9.47703 12.8025V4.48785'
                  stroke='#808080' stroke-miterlimit='10' stroke-linecap='round' />
              </svg>

              <strong class='' v-if='file && file.name'>{{ file.name }}</strong>

              <strong v-if='!file.name'>Clique aqui para anexar o arquivo.</strong>
            </label>
          </section>
        </section>

        <template v-slot:overlay>
          <div class="text-center loading-spinner">
            <b-spinner
              style="width: 3rem; height: 3rem"
              variant="primary"
              label="Large Spinner"
            ></b-spinner>
            <h5 class="text-primary">Buscando...</h5>
          </div>
        </template>
      </b-overlay>

      <template #modal-footer>
        <section class="modal-font-family w-100">
          <section class="w-100">
            <b-alert
              show
              variant='danger'
              :class='{ hidden: !errors }'
            >
              {{ errors }}
            </b-alert>
          </section>

          <section class="w-100 d-flex justify-content-between">
            <base-button :disabled="loading" @click="closeModalTagEmailAutomation()" class="w-50 pr-2 btn-cancel">
              <span>Cancelar</span>
            </base-button>

            <b-overlay
              :show="loading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block w-50 pl-2"
            >
              <base-button
                class="w-100 btn-add d-flex align-items-center justify-content-center"
                @click="submit()"
                :disabled="loading"
              >
                <span v-if="tagEmailAutomationId" class="mr-2">Editar e-mail</span>
                <span v-else class="mr-2">Adicionar e-mail</span>
              </base-button>
            </b-overlay>
          </section>

        </section>
      </template>
    </b-modal>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import XLSX from 'xlsx'
import { requiredIf } from '@/utils/validators'
import { upload } from '@/utils/upload'

export default {
  name: 'ModalTagEmailAutomation',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      checked: false,
      loadingOverlay: false,
      loading: false,
      tagsTagEmailAutomation: [],
      emailSendingTypeMultiple: 'MULTIPLE',
      emailSendingType: [
        {
          value: 'FIRST_TIME_ONLY',
          text: 'Enviar e-mail apenas na primeira vez que o usuário receber a tag'
        },
        {
          value: 'MULTIPLE',
          text: 'Enviar mais de um e-mail após o usuário receber a tag.'
        }
      ],
      fileEmails: {},
      file: {},
      emails: [],
      tagEmailAutomation: {
        emails: [],
        fileUrl: null,
        fileName: null,
        triggerTag: null,
        emailSubject: null,
        emailBody: null,
        emailSendingType: null,
        maxSendCount: null,
        sendIntervalDays: null
      }
    }
  },
  props: {
    tagEmailAutomationId: { type: String, required: false, default: null }
  },
  computed: {
    errors() {
      return this.$store.getters['access/error']
    }
  },
  validations() {
    return {
      tagEmailAutomation: {
        triggerTag: { },
        emailSubject: { required },
        emailBody: { required },
        emailSendingType: { required },
        maxSendCount: { requiredIf: requiredIf(this.tagEmailAutomation.emailSendingType === this.emailSendingTypeMultiple) },
        sendIntervalDays: { requiredIf: requiredIf(this.tagEmailAutomation.emailSendingType === this.emailSendingTypeMultiple) }
      }
    }
  },
  methods: {
    ...mapActions('tags', {
      handleTagsInstructionalVideos: 'handleTagsInstructionalVideos'
    }),
    ...mapActions('tagEmailAutomation', {
      handleCreate: 'handleCreate',
      handleGet: 'handleGet',
      handleUpdate: 'handleUpdate'
    }),

    deleteEmails(){
      this.emails = []
    },

    uploadFile(event) {
      const [file] = Array.from(event.target.files)
      this.file = file
    },

    async uploadEmails(event) {
      try {
        await this.$store.dispatch('access/updateError', ``)
        const [file] = Array.from(event.target.files)
        this.fileEmails = file
        this.emails = []
        const fileReader = new FileReader()
        fileReader.onload = async (event) => {
          const data = event.target.result
          const workbook = XLSX.read(data, {
            type: 'array'
          })

          if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
            await this.$store.dispatch('access/updateError', 'A planilha não contém nenhuma aba.')
            this.fileEmails = {}
            this.emails = []
            return
          }

          const firstSheetName = workbook.SheetNames[0]
          const firstSheet = workbook.Sheets[firstSheetName]

          if (!firstSheet) {
            await this.$store.dispatch('access/updateError', `Não foi possível ler a aba "${firstSheetName}".`)
            this.fileEmails = {}
            this.emails = []
            return
          }

          const rows = XLSX.utils.sheet_to_json(firstSheet)

          if (!rows || rows.length === 0) {
            await this.$store.dispatch('access/updateError', 'A planilha está vazia.')
            this.fileEmails = {}
            this.emails = []
            return
          }


          const getColumnValue = (row, columnName) => {
            const key = Object.keys(row).find((k) => k.trim().toLowerCase() === columnName)
            return key ? row[key] : undefined
          }

          if (!rows.some((x) => getColumnValue(x, 'email') !== undefined)) {
            await this.$store.dispatch('access/updateError', `Arquivo incorreto, use o arquivo modelo de exemplo!`)
          } else {
            this.emails = rows
              .map((x) => getColumnValue(x, 'email'))
              .filter((value) => value)
              .map((value) => value.toString().trim())
          }
        }
        fileReader.readAsArrayBuffer(file)
      } catch (e) {

      }
    },

    exportToExcel() {
      const data = this.tagsTagEmailAutomation.filter(x => x.tag === this.tagEmailAutomation.triggerTag).map((x) => {
        return {
          Tag: x.tag,
          ['Descrição']: x.description,
          ['Gatilho/Tarefa/Rotina']: x['Gatilho/Tarefa/Rotina']
        }
      })

      const worksheet = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Planilha1')
      XLSX.writeFile(workbook, `${this.tagEmailAutomation.triggerTag}.xlsx`)
    },

    async showModal() {
      try {
        await this.$store.dispatch('access/updateError', ``)
        this.fileEmails = {}
        this.file = {}
        this.emails = []
        this.tagEmailAutomation = {
          emails: [],
          fileUrl: null,
          fileName: null,
          triggerTag: null,
          emailSubject: null,
          emailBody: null,
          emailSendingType: null,
          maxSendCount: null,
          sendIntervalDays: null,
        }
        const { items } = await this.handleTagsInstructionalVideos()

        this.tagsTagEmailAutomation = items.map((x) => {
          return {
            ...x,
            tagDescription: `${x.description}${x.tag ? ` (${x.tag})` : ''}`
          }
        })

        if (this.tagEmailAutomationId) {
          this.loadingOverlay = true
          const { data: dataResponse } = await this.handleGet(this.tagEmailAutomationId)
          const { data } = dataResponse
          this.tagEmailAutomation = data
          const { emails } = data || {}
          this.emails = emails
          this.loadingOverlay = false
        }
      } catch (e) {

      }
    },

    closeModalTagEmailAutomation() {
      this.$bvModal.hide('modalTagEmailAutomation')
    },

    async submit() {
      try {
        await this.$store.dispatch('access/updateError', ``)
        const validate = await this.v$.$validate()
        if (!validate) {
          await this.$store.dispatch('access/updateError', `Preencha todos os campos corretamente`)
          this.loading = false
          return
        }

        this.tagEmailAutomation.emails = this.emails && this.emails.length > 0
          ? this.emails.filter((x) => x).map((x) => x.toString().trim())
          : []

        if ((!this.tagEmailAutomation.emails || this.tagEmailAutomation.emails.length <= 0) && !this.tagEmailAutomation.triggerTag) {
          await this.$store.dispatch('access/updateError', `É necessário importar uma lista de e-mails ou selecionar uma tag de gatilho!`)
          return
        }

        if (this.tagEmailAutomation.emails && this.tagEmailAutomation.emails.length > 0 && this.tagEmailAutomation.triggerTag) {
          await this.$store.dispatch('access/updateError', `Importe apenas a lista de e-mails ou selecione uma tag de gatilho.`)
          return
        }
        this.loading = true
        if (this.file && this.file.name) {
          const { name } = this.file || {}
          try {
            this.tagEmailAutomation.fileUrl = await upload(this.file)
          } catch (e) {

          }
          this.tagEmailAutomation.fileName = name
        }

        let response = {}
        if (this.tagEmailAutomationId) {
          response = await this.handleUpdate(this.tagEmailAutomation)
        } else {
          response = await this.handleCreate(this.tagEmailAutomation)
        }
        const { data, status, errors } = response
        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })

        this.closeModalTagEmailAutomation()
        this.loading = false
        this.$emit('load')
      } catch (e) {
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-instructional-videos {
  .header {
    .title {
      font-weight: 700;
      font-size: 18px;
      color: var(--navy-blue);
    }

    .sub-title {
      font-weight: 400;
      font-size: 15px;
      color: #808080;
    }

    .btn-add-tutorial {
      font-weight: 400;
      font-size: 15px;
      border: 1px solid #AEBBCD;
      border-radius: 6px;
      color: #6D7989;
      background: #FFFFFF;
    }
  }

  label {
    font-weight: 700;
    font-size: 16px;
    color: #262626;
    margin-bottom: 0;
  }

  .link-model {
    text-decoration: underline;
    font-weight: 400;
    font-size: 14px;
    color: var(--navy-blue);
  }

  .file-uploaded {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    color: var(--navy-blue);
    border: 1px solid var(--navy-blue);

    padding: 6px 12px;

    border-radius: 4px;

    transition: all 0.2s ease-in-out;

    text-decoration: none;

    cursor: pointer;
  }

  .file-product {
    border-radius: 6.25px;
    border: 1px solid #808080;
    width: 100%;
    height: 40px;
    cursor: pointer;

    span {
      color: #808080;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
    }

    strong {
      color: #808080;
      font-size: 15px;
      font-weight: 700;
    }

  }

}
.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}
.phones-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 0;
}
</style>
